import { FC, ImgHTMLAttributes } from 'react';
import { Box, BoxProps } from '@mui/material';
import fallbackServiceLogo from '@assets/logo/service-logo.png';

export interface IPackageDealAndServiceLogoViewerProps extends ImgHTMLAttributes<HTMLImageElement> {
	containerProps?: BoxProps;
}

export const PackageDealAndServiceLogoViewer: FC<IPackageDealAndServiceLogoViewerProps> = ({ containerProps, style, ...props }) => {
	return (
		<Box display="flex" alignItems="center" justifyContent="center" minWidth={100} maxWidth={100} {...containerProps}>
			<img
				style={{ width: 'auto', height: 60, maxWidth: '100%', ...style }}
				onError={(ev) => ((ev.target as HTMLImageElement).src = fallbackServiceLogo)}
				{...props}
			/>
		</Box>
	);
};
